import { cn } from '@/lib/utils'
import { useRollStore } from '@/features/roll/store/roll-store'
import { Dices } from 'lucide-react'

export function RollStacks() {
  const { canRoll, canPick } = useRollStore()
  const maxStacks = 3

  return (
    <div className="flex items-center gap-1.5 w-[4.5rem] justify-center">
      {Array.from({ length: maxStacks }).map((_, index) => (
        <Dices
          key={index}
          className={cn(
            "h-5 w-5 transition-colors duration-300",
            index < canRoll
              ? canPick
                ? "text-primary"
                : "text-destructive"
              : "text-muted-foreground/50"
          )}
        />
      ))}
    </div>
  )
} 